<template>
    <div>
        <!-- ACTION BAR -->
        <div class="container-action-bar">
            <CompassTooltip :arrow="false">
                <template #content>
                    <span>{{ labels.showHistoryTooltip }}</span>
                </template>
                <span>
                    <CompassIconButton
                        icon="history"
                        size="small"
                        :active="displayHistory"
                        @click="$emit('toggleHistory')"
                    />
                </span>
            </CompassTooltip>
            <CompassTooltip :arrow="false">
                <template #content>
                    <span>{{ pinStatusLabel }}</span>
                </template>
                <span>
                    <CompassIconButton
                        icon="pin"
                        size="small"
                        :active="isPinned"
                        @click.stop="onClickPin"
                    />
                </span>
            </CompassTooltip>
            <CompassTooltip v-if="isNewPanelEnabled" :arrow="false">
                <template #content>
                    <span>{{ labels.seeDetailsTooltip }}</span>
                </template>
                <span
                    ><CompassIconButton
                        icon="panel-right-expand"
                        size="small"
                        @click="previewElement()"
                /></span>
            </CompassTooltip>
            <!-- Custom tooltip for 'more actions' -->
            <div ref="customTooltip" :class="customTooltipClasses">
                {{ labels.moreActionsTooltip }}
            </div>
            <span v-if="canEdit || canDelete">
                <CompassMenu
                    ref="actionBarMenu"
                    size="small"
                    placement="top-end"
                    :disabled="!isActionBarVisible"
                >
                    <CompassIconButton
                        icon="action"
                        size="small"
                        @click="handleCustomTooltipVisibility"
                        @mouseenter="handleCustomTooltipVisibility"
                        @mouseleave="handleCustomTooltipVisibility"
                    />
                    <template #dropdown>
                        <CompassMenuItem
                            v-if="canEdit"
                            :label="labels.menuItemModify"
                            @click="editElement(oneLog)"
                        />
                        <CompassMenuItem
                            v-if="canDelete"
                            :label="labels.menuItemDelete"
                            @click="deleteModal = true"
                        />
                    </template>
                </CompassMenu>
            </span>
        </div>
        <CompassDialog
            :visible.sync="deleteModal"
            size="small"
            :title="$t.__('timeline.timelineActionBar.TimelineActionBarPhoneCall.call_deleting')"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="typographies-paragraph-medium-regular">
                        {{ $l10n.__('Confirmez-vous vouloir supprimer cet appel ?') }}
                    </p>
                    <ul class="typographies-paragraph-medium-regular">
                        <li>
                            -
                            {{ $l10n.__('Il n’apparaitra plus pour aucun de vos collaborateurs.') }}
                        </li>
                        <li>- {{ $l10n.__('Ceci est une action définitive.') }}</li>
                    </ul>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        :disabled="isDeletePending"
                        @click="deleteModal = false"
                    />
                    <CompassButton
                        :label="
                            $t.__(
                                'timeline.timelineActionBar.TimelineActionBarPhoneCall.confirm_call_deleting',
                            )
                        "
                        type="primary-destructive"
                        :loading="isDeletePending"
                        class="ml-2"
                        @click="deleteElement(oneLog)"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import TimelineActionBar from 'vcomponents/timeline/timelineActionBar/TimelineActionBar.vue';

export default {
    name: 'TimelineActionBarPhoneCall',
    extends: TimelineActionBar,
    data() {
        return {
            deleteModal: false,
            isDeletePending: false,
        };
    },
    methods: {
        previewElement() {
            this.openDetail(
                'phonecall',
                () =>
                    EventBus.emit('timeline:refreshLog', {
                        objectType: 'phonecall',
                        objectId: this.oneLog.objectid,
                    }),
                () => EventBus.emit('timeline:refresh'),
                () => EventBus.emit('timeline:refresh'),
                [...this.oneLog.linkeds, ...(this.oneLog.contacts?.list ?? [])],
            );
        },
        editElement(onelog) {
            Activities.openPhoneCallForm(onelog.objectid, this.linkedid, this.linkedtype, () =>
                EventBus.emit('timeline:refreshLog', {
                    objectType: 'phonecall',
                    objectId: onelog.objectid,
                }),
            );
        },
        deleteElement(onelog) {
            this.isDeletePending = true;
            axios
                .post('/?_f=phonecall_listing', { action: 'delete', callid: onelog.objectid })
                .then(() => {
                    this.deleteModal = false;
                    this.$nextTick(() => {
                        EventBus.emit('timeline:deleteLog', {
                            objectType: 'phonecall',
                            objectId: onelog.objectid,
                        });
                    });
                })
                .finally(() => (this.isDeletePending = false));
        },
    },
};
</script>

<style lang="scss">
.dialog {
    &__default {
        padding-bottom: 24px;
        p {
            margin: 0 0 var(--spacing-3);
        }
        ul {
            margin: 0;
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        padding: 0 32px 24px 32px;
    }
}
</style>
